module.exports = __webpack_public_path__ + "static/sport/swiper-6.ab42579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-6.png
// module id = sp8x
// module chunks = 0